import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

type CreateActivityDto = {
  name: string
}

export const useCreateActivityMutation = (
  options?: UseMutationOptions<string, AxiosError, CreateActivityDto>
) =>
  useMutation<string, AxiosError, CreateActivityDto>({
    ...options,
    mutationFn: async (data) => {
      const res = await httpClient.post("/admin/activity", data)
      return res.data
    },
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      await queryClient.invalidateQueries(["findAllActivities"])
      notifications.show({
        title: "Added",
        message: "Successfully added activity",
        color: "green",
      })
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
      notifications.show({
        title: "Error",
        message: "Failed to add activity",
        color: "red",
      })
    },
  })
